module.exports = __webpack_public_path__ + "img/DE00821.93e3807d.png";